import { ElementRef, Output, EventEmitter } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { AuthService } from "src/app/Auth/auth.service";
import { Router } from "@angular/router";
import { AngularFirestore } from "@angular/fire/firestore";

@Component({
  selector: "app-rigister",
  templateUrl: "./rigister.component.html",
  styleUrls: ["./rigister.component.scss"]
})
export class RegisterComponent implements OnInit {
  ShowPassword = false;
  isLoading = false;
  errMessage;

  constructor(
    private router: Router,
    private fs: AngularFirestore,

    private auth: AuthService
  ) {}
  validatingForm = new FormGroup({
    firstName: new FormControl("", [Validators.minLength(5)]),
    lastName: new FormControl(""),
    email: new FormControl("", Validators.required),
    password: new FormControl("", [
      Validators.required,
      Validators.minLength(5)
    ]),
    avatar: new FormControl("")
  });
  ngOnInit() {}
  addUser(v: any) {
    this.isLoading = true;
    const email = v.value.email;
    const password = v.value.password;

    const fs = v.value.firstName;
    const ls = v.value.lastName;
    const fullName = `${fs} ${ls}`;

    this.auth
      .signUp(email, password)
      .then(data => {
        this.isLoading = false;
        // let id = data.user.uid;

        // //this.router.navigate(['/'])
        // this.fs
        //   .collection("users")
        //   .doc(id)
        //   .set({
        //     id: id,
        //     email: email,
        //     password: password,
        //     firstName: fs,
        //     lastName: ls,
        //     fullName: fullName
        //   });
      })
      .catch(err => {
        console.log(err);
        this.isLoading = false;
        this.errMessage = err.message;
      });
    v.reset();
  }
  toggleEye() {
    this.ShowPassword = !this.ShowPassword;
  }
}
